const B_1 = [
    {
        title: '退回',
        path: '/manage/business/back/list'
    }
]

export default {
    path: 'back',
    component: () => import(/*webpackChunkName: 'business-back'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/list'),
            meta: {
                title: '退回',
                topNav: true,
                bread: B_1
            },
        },
        {
            path:"log",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/rizhi'),
            meta: {
                title: '查看退回日志',
                topNav: true,
                bread: B_1
            },
        },
        {
            path:"backprojectth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-projectth/list'),
            meta: {
                title: '项目退回',
                bread: [
                    ...B_1,
                    {
                        title: '项目退回',
                        path: '/manage/business/back/backprojectth/list'
                    },
                ]
            },
        }, 
        {
            path:"backzbxmth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zbxmth/list'),
            meta: {
                title: '招标项目退回',
                bread: [
                    ...B_1,
                    {
                        title: '招标项目退回',
                        path: '/manage/business/back/backzbxmth/list'
                    },
                ]
            },
        }, 
        {
            path:"backbdth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-bdth/list'),
            meta: {
                title: '标段退回',
                bread: [
                    ...B_1,
                    {
                        title: '标段退回',
                        path: '/manage/business/back/backbdth/list'
                    },
                ]
            },
        },
        {
            path:"backzbwjth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zbwjth/list'),
            meta: {
                title: '招标文件退回',
                bread: [
                    ...B_1,
                    {
                        title: '招标文件退回',
                        path: '/manage/business/back/backzbwj/list'
                    },
                ]
            },
        },
        {
            path:"backkbjlth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-kbjlth/list'),
            meta: {
                title: '开标记录退回',
                bread: [
                    ...B_1,
                    {
                        title: '开标记录退回',
                        path: '/manage/business/back/backkbjl/list'
                    },
                ]
            },
        },
        {
            path:"backexfkbjlth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-exfkbjlth/list'),
            meta: {
                title: '二信封开标记录退回',
                bread: [
                    ...B_1,
                    {
                        title: '二信封开标记录退回',
                        path: '/manage/business/back/backexfkbjlth/list'
                    },
                ]
            },
        },
        {
            path:"backzgscth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zgscth/list'),
            meta: {
                title: '资格审查退回',
                bread: [
                    ...B_1,
                    {
                        title: '资格审查退回',
                        path: '/manage/business/back/backzgscth/list'
                    },
                ]
            },
        },
        {
            path:"backpbbgth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-pbbgth/list'),
            meta: {
                title: '评标报告退回',
                bread: [
                    ...B_1,
                    {
                        title: '评标报告退回',
                        path: '/manage/business/back/backpbbgth/list'
                    },
                ]
            },
        },
        {
            path:"backdbbgth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-dbbgth/list'),
            meta: {
                title: '定标报告退回',
                bread: [
                    ...B_1,
                    {
                        title: '定标报告退回',
                        path: '/manage/business/back/backdbbgth/list'
                    },
                ]
            },
        },
        {
            path:"backzbhxrth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zbhxrth/list'),
            meta: {
                title: '中标候选人退回',
                bread: [
                    ...B_1,
                    {
                        title: '中标候选人退回',
                        path: '/manage/business/back/backzbhxrth/list'
                    },
                ]
            },
        },
        {
            path:"backzbggth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zbggth/list'),
            meta: {
                title: '招标公告退回(不推送其他平台)',
                bread: [
                    ...B_1,
                    {
                        title: '招标公告退回(不推送其他平台)',
                        path: '/manage/business/back/backzbggth/list'
                    },
                ]
            },
        },
        {
            path:"backzbhxrgsth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zbhxrgsth/list'),
            meta: {
                title: '中标候选人公示退回(不推送其他平台)',
                bread: [
                    ...B_1,
                    {
                        title: '中标候选人公示退回(不推送其他平台)',
                        path: '/manage/business/back/backzbhxrgsth/list'
                    },
                ]
            },
        },
        {
            path:"backzhongbggth/list",
            component: () => import(/*webpackChunkName: 'business-back'*/ '@views/manage/views/business/back/back-zhongbggth/list'),
            meta: {
                title: '中标公告退回(不推送其他平台)',
                bread: [
                    ...B_1,
                    {
                        title: '中标公告退回(不推送其他平台)',
                        path: '/manage/business/back/backzhongbggth/list'
                    },
                ]
            },
        },
        
    ]
}
